import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import { HomeContentSection } from '@app/modules/Home/Data/types'

export const fetchHomeContent = async (page: string): Promise<HomeContentSection> => {
  const response = await apiClient.get(`${Endpoint.getHomeContent}/${page}`)
  return response.data
}
